import authReducer from './authReducer'
import userDetailReducer from './userDetailReducer'

export const mainAuthReducer = {
  auth: authReducer,
  authUser: userDetailReducer,
};
